import React from 'react'
import useData from '../Hooks/useData'

const About = () => {
  const fetchData = useData()

  // console.log(fetchData.aboutUs);
  

  return (
    <div>
      <div className='m-8'>
        <h1 className='font-semibold text-3xl text-center my-4'>About Us</h1>
        <p className='text-gray-700 text-xl'>The objective of <strong>"Akoi Foundation"</strong> is to establish a new direction in the field of animal welfare. This organization symbolizes a shelter and safety for the innocent animals that are neglected and suffering in society. Our commitment is to protect the rights of animals and make dedicated efforts for their care.</p>
        <br />
        <p className='text-gray-700 text-xl'>Animals are not just a part of our lives; they also have an equal right to live on this Earth. In our society, cruelty and insensitivity towards animals are often seen, and to stop this, "Akoi Foundation" has taken a step forward. Our aim is to make people understand their responsibilities and compassion towards animals, so that positive change comes in society regarding animal welfare.</p>
        <br />
        <p className='text-xl text-gray-700 '>Through the various campaigns, awareness programs, and conservation efforts we conduct, we ensure that every animal receives love, care, and safety in their life. By joining the Akoi Foundation, we can all work together on this sensitive issue and create a better future for animals.</p>
      </div>
    </div>
  )
}

export default About